import * as React from 'react';
import { Theme, Grid } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { OrderProduct, Shopper, SetProduct } from 'common/types';
import ProductCustomValueInput from '../../ProductCustomValueInput';

interface OwnProps {
	product: OrderProduct | SetProduct;
	productId: string;
	setProduct: boolean;
	setIndex?: number;
	shopper: Shopper;
	updateActiveShopperId: (activeShopperId: string | null) => void;
}

type Props = OwnProps & WithStyles<typeof styles>;

export const ProductCustomValues = (props: Props) => {
	const { classes, product, shopper, productId, setProduct, setIndex } = props;

	const isProductReturned = () => {
		if ((product as SetProduct).returnedDate || (product as OrderProduct).endDateReturned) {
			return true;
		}
		return false;
	};

	const renderProductCustomValueInputs = () => {
		if (!product.customValuesToCollect) {
			return null;
		}
		const customValueInputElements = product.customValuesToCollect.map((customValue, index) => {
			return (
				<div key={index}>
					<ProductCustomValueInput
						product={product}
						shopper={shopper}
						productId={productId}
						setIndex={setProduct && setIndex != null ? setIndex : null}
						name={customValue.name}
						type={customValue.type}
						value={
							product.customValues && product.customValues[index]
								? product.customValues[index].value
								: ''
						}
						disabled={isProductReturned()}
					/>
				</div>
			);
		});
		return customValueInputElements;
	};

	return product.customValuesToCollect && product.customValuesToCollect.length ? (
		<Grid
			item
			xs={12}
			sm={product.collectDin ? 6 : 12}
			lg={6}
			onClick={(e) => {
				e.stopPropagation();
				props.updateActiveShopperId(shopper.id);
			}}
			className={product.collectDin ? classes.order2 : classes.order2smDown}
		>
			{!(props.product as SetProduct).removedFromParent ? renderProductCustomValueInputs() : ''}
		</Grid>
	) : null;
};

const styles = (theme: Theme) =>
	createStyles({
		order2: {
			order: 2,
		},
		order2smDown: {
			[theme.breakpoints.down('lg')]: {
				order: 2,
			},
		},
	});

export default withStyles(styles)(ProductCustomValues);
